// Global business contact number in a human-friendly format
// Edit this value to update the phone number across the entire site.
export default "+1 612-424-0609";
